// extracted by mini-css-extract-plugin
export var button = "RecordedDemoButton-module--button--3766d";
export var content = "RecordedDemoButton-module--content--3ae8f";
export var icon = "RecordedDemoButton-module--icon--86781";
export var suptitle = "RecordedDemoButton-module--suptitle--383b5";
export var title = "RecordedDemoButton-module--title--b642b";
export var wrapper = "RecordedDemoButton-module--wrapper--0c74b";